import React from 'react';
import PortfolioTab from '../../components/vendor/profile/PortfolioTab';

const VendorPortfolio = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="p-4 sm:p-6">
        <div className="mb-6 sm:mb-8">
          <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-2">Portfolio</h1>
          <p className="text-sm sm:text-base text-gray-600">Manage your portfolio images to showcase your best work.</p>
        </div>

        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4 sm:p-6 lg:p-8">
          <PortfolioTab />
        </div>
      </div>
    </div>
  );
};

export default VendorPortfolio;
